var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaywrightSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#2EAD33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 6h6.5c1.9 0 3.5 1.6 3.5 3.5S15.4 13 13.5 13H10v5H7V6zm3 4h3.5c.8 0 1.5-.7 1.5-1.5S14.3 7 13.5 7H10v3z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaywrightSvgrepoCom);
export default __webpack_public_path__ + "static/media/playwright-svgrepo-com.e016970edbbc701ff33df87f9603ed71.svg";
export { ForwardRef as ReactComponent };